var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    { key: _vm.peer.id },
    [
      _c(
        "v-list-item-avatar",
        { attrs: { color: "secondary" } },
        [_c("v-icon", { attrs: { dark: "" } }, [_vm._v("mdi-account-circle")])],
        1
      ),
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", {
            domProps: {
              textContent: _vm._s(
                _vm.peer.name != "" ? `${_vm.peer.name}` : `Anonymous`
              ),
            },
          }),
          _c("v-list-item-subtitle", {
            domProps: { textContent: _vm._s(_vm.peer.roleName.toUpperCase()) },
          }),
        ],
        1
      ),
      _vm.peer.roleName == "waiting-room" && _vm.local_peer.roleName != "guest"
        ? _c(
            "v-list-item-icon",
            { staticClass: "pt-2" },
            [
              _c(
                "v-btn",
                {
                  attrs: { "x-small": "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.meeting.hmsActions.changeRole(
                        _vm.peer.id,
                        "guest",
                        true
                      )
                    },
                  },
                },
                [_vm._v("Admit")]
              ),
            ],
            1
          )
        : _c(
            "v-list-item-icon",
            { staticClass: "pt-2" },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", "x-small": "" },
                  on: {
                    click: function ($event) {
                      return _vm.meeting.enablePeerAudio(
                        _vm.peer,
                        !_vm.meeting.peer_audio_enabled[_vm.peer.id]
                      )
                    },
                  },
                },
                [
                  !_vm.meeting.peer_audio_enabled[_vm.peer.id]
                    ? _c("v-icon", [_vm._v("mdi-microphone-off")])
                    : _c("v-icon", [_vm._v("mdi-microphone")]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", "x-small": "" },
                  on: {
                    click: function ($event) {
                      return _vm.meeting.enablePeerVideo(
                        _vm.peer,
                        !_vm.meeting.peer_video_enabled[_vm.peer.id]
                      )
                    },
                  },
                },
                [
                  !_vm.meeting.peer_video_enabled[_vm.peer.id]
                    ? _c("v-icon", [_vm._v("mdi-video-off")])
                    : _c("v-icon", [_vm._v("mdi-video")]),
                ],
                1
              ),
              _vm.meeting.permissions.changeRole
                ? _c("meeting-participant-menu", { attrs: { peer: _vm.peer } })
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }